<div class="tpa-details">
  <div class="tpa-details__header">
    <div class="tpa-details__header-column tpa-details__header-column--left">
      <app-tpa-filter></app-tpa-filter>
    </div>

    <div class="tpa-details__header-column tpa-details__header-column--center">
      @if (detailViewData.length) {
        <app-quick-search [data]="detailViewData"
                          [options]="searchOptions"
                          (filteredDataChange)="onFilteredDataChange($event)"
        ></app-quick-search>
      }
    </div>

    <div class="tpa-details__header-column tpa-details__header-column--right">
      <app-tpa-view-toggle (viewAction)="onViewAction($event)"></app-tpa-view-toggle>
    </div>
  </div>


  <div class="tpa-details__content" [class.no-data]="!detailViewData.length || !filteredData.length">
    @if (detailViewData && detailViewData.length > 0) {
      @if (currentView === tpaView.detail) {
        <app-tpa-detail-view [detailViewData]="filteredData"></app-tpa-detail-view>
      } @else if (currentView === tpaView.group) {
        <app-tpa-group-view [groupViewData]="groupViewData"></app-tpa-group-view>
      }
    }

    @if (!detailViewData.length || !filteredData.length) {
      <p>No data for this search</p>
    }

  </div>

  <div class="tpa-details__button">
    <button mat-raised-button color="primary" type="submit" (click)="back()">New Search</button>
  </div>

</div>

<app-tpa-dialog></app-tpa-dialog>





